module.exports = __webpack_public_path__ + "static/media/Purity.9ee251e9.jpg";